import globals from '@/globals';

const DEFAULT_LOCALE = 'en-US';

const parseLocale = (settings = { user: {} }) => {
  try {
    const { locale } = settings.user;
    const normalized = new Intl.Locale(locale.replace('_', '-'));
    return normalized.toString();
  } catch (exception) {
    return DEFAULT_LOCALE;
  }
};

export default {
  state: {
    locale: parseLocale(globals.I && globals.I.settings),
  },
  getters: {},
};
